import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { Box } from "@mui/material";
import "../../components-styles.scss";

type SearchBarProps = {
    setSearchQuery: Function;
};

const SearchBar = ({ setSearchQuery }: SearchBarProps) => (
    <form className="search-bar">
        <Box
            sx={{
                display: "flex",
                padding: "0.5rem 1rem",
                alignItems: "center",
                borderRadius: "0.625rem",
                background: "#F3F5F6",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    // gap: "1rem",
                    flex: "1 0 0",
                }}
            >
                <IconButton type="submit" aria-label="search">
                    <SearchIcon width="1.5rem" height="1.5rem" />
                </IconButton>
                <TextField
                    id="search-bar"
                    // className="text"
                    sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                    }}
                    onInput={(e: any) => {
                        if (e?.target) {
                            setSearchQuery(e?.target?.value);
                        }
                    }}
                    variant="outlined"
                    placeholder="Recherche..."
                    size="small"
                />
            </Box>
        </Box>
    </form>
);

export default SearchBar;
